<template>
  <div>
    <div class="home">
      <!-- <div ref="homeImg" class="home-shuffling">
        <img class="home-img" src="../assets/home.jpg">
        <el-carousel :interval="5000" arrow="always">
          <el-carousel-item><img class="home-img" src="../assets/home-swiper1.png"></el-carousel-item>
          <el-carousel-item><img class="home-img" src="../assets/home-swiper2.png"></el-carousel-item>
          <el-carousel-item><img class="home-img" src="../assets/home-swiper3.png"></el-carousel-item>
        </el-carousel>
      </div> -->
      <div style="overflow: hidden;position: relative;">
        <swiper :options="swiperOption" ref="mySwiper">
          <!-- <swiper-slide>
            <img class="home-img" src="../assets/home-swiper1.png">
          </swiper-slide>
          <swiper-slide>
            <img class="home-img" src="../assets/home-swiper2.png">
          </swiper-slide>
          <swiper-slide>
            <img class="home-img" src="../assets/home-swiper3.png">
          </swiper-slide> -->

          <swiper-slide v-for="(item,index) in homePageImg.part1.banners" :key="index">
              <img class="brand-icons" :src="'https://branew-pic.oss-cn-beijing.aliyuncs.com/' + item.image">
          </swiper-slide>

          <div class="swiper-button-prev" slot="button-prev"></div>
          <div  class="swiper-button-next" slot="button-next"></div>
          <div class="swiper-pagination"  slot="pagination"></div>
        </swiper>
      </div>
      
      <div class="home-nav">
        <div ref="qudao" v-show="qudaoShow" class="home-service">
          <img class="service-img animate__animated animate__fadeInUp" src="../assets/black-logo.png">
          <div class="home-title animate__animated animate__fadeInUp">联系我们</div>
          <div class="home-paper animate__animated animate__fadeInUp">我们为您提供全方位的洗衣服务及护理方案</div>
          <div class="service-project animate__animated animate__fadeInUp" v-for="(item,index) in serviceProject" :key="index">
            <div class="project-img">
              <img class="goods-list-project-img" :src="item.icon"  alt="">
              <img class="goods-project-img" :src="item.icon"  alt="">
            </div>
            <div class="project-title"> {{item.title}} </div>
          </div>
          <div class="news-btn animate__animated animate__fadeInUp" @click="$router.push('/serviceProject')">了解更多</div>
        </div>
        <div class="home-news">
          <img ref="homenews1" v-show="homenewsShow1" class="service-img animate__animated animate__fadeInUp" src="../assets/black-logo.png">
          <div ref="homenews2" v-show="homenewsShow2" class="home-title animate__animated animate__fadeInUp">新闻资讯</div>
          <div class="news-nav">
            <div ref="homenews3" v-show="homenewsShow3" class="news-information animate__animated animate__fadeInLeft" @click="$router.push(`/newsDetails/${newsDataLeft.id}`)" style="margin-right: 3rem;">
              <img :src="'https://branew-pic.oss-cn-beijing.aliyuncs.com/' + newsDataLeft.thumbnail" alt="">
              <div class="news-title">{{newsDataLeft.title}}</div>
              <div class="news-time">{{newsDataLeft.timePublish | formatterDate}}</div>
            </div>
            <div ref="homenews4" v-show="homenewsShow4" class="news-information animate__animated animate__fadeInRight" @click="$router.push(`/newsDetails/${newsDataRight.id}`)">
              <img :src="'https://branew-pic.oss-cn-beijing.aliyuncs.com/' + newsDataRight.thumbnail" alt="">
              <div class="news-title">{{newsDataRight.title}}</div>
              <div class="news-time">{{newsDataRight.timePublish | formatterDate}}</div>
            </div>
          </div>
          <div ref="homenews5" v-show="homenewsShow5" class="news-btn animate__animated animate__fadeInUp" @click="$router.push('/newsInformation')">阅读更多</div>
        </div>
      </div>
    </div>

    <div class="home-mobile">
      <div class="home-mobile-shuffling">
        <img class="home-mobile-img" src="../assets/home.png">
      </div>
      <div class="home-mobile-nav">
        <div class="home-mobile-service">
          <img class="service-img" src="../assets/ax-logo.png">
          <div class="home-title">联系我们</div>
          <div class="home-paper">我们为您提供全方位的洗衣服务及护理方案</div>
          <div class="mobile-service-project" v-for="(item,index) in serviceProjectJian" :key="index">
            <div class="mobile-project-img">
              <img src="../assets/ax-logo.png"  alt="">
            </div>
            <div class="mobile-project-title"> {{item.title}} </div>
          </div>
          <div class="mobile-service-btn" @click="$router.push('/serviceProject')">了解更多</div>
        </div>
        <div class="home-mobile-news">
          <img class="service-img" src="../assets/ax-logo.png">
          <div class="home-title">最新动态</div>
          <div class="mobile-news-nav">
            <div class="mobile-news-information">
              <img src="../assets/home.png" alt="">
              <div class="mobile-news-list">
                <div class="news-title">祝贺布瑞琳北京、河北区域新店相继开业！</div>
                <div class="news-time">2020-01-01</div>
              </div>
            </div>
            <div class="mobile-news-information">
              <img src="../assets/home.png" alt="">
              <div class="mobile-news-list">
                <div class="news-title">祝贺布瑞琳北京、河北区域新店相继开业！</div>
                <div class="news-time">2020-01-01</div>
              </div>
            </div>
          </div>
          <div class="mobile-news-btn" @click="$router.push('/newsInformation')">阅读更多</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HelloWorld from '@/components/HelloWorld.vue'
import animated from 'animate.css'
import dayjs from 'dayjs'

export default {
  name: 'Home',
  components: {
    HelloWorld
  },

  data(){
    return {
      homePageImg: [],
      swiperOption: {
        centeredSlides: true,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next', //前进按钮的css选择器或HTML元素。
          prevEl: '.swiper-button-prev', //后退按钮的css选择器或HTML元素。
        },
        // 如果需要分页器
        pagination: {
          el:'.swiper-pagination',
          clickable: true,
        },
      },
      serviceProject:[
        {
          icon:require('@/assets/home-clothing1.png'),
          title:"精品衣物清洗"
        },
        {
          icon:require('@/assets/home-clothing2.png'),
          title:"鞋靴养护修护"
        },
        {
          icon:require('@/assets/home-clothing3.png'),
          title:"精品改衣整修"
        },
        {
          icon:require('@/assets/home-clothing4.png'),
          title:"家纺用品洗护"
        },
        {
          icon:require('@/assets/home-clothing5.png'),
          title:"奢品洁护保养"
        },
        {
          icon:require('@/assets/home-clothing6.png'),
          title:"特种衣物洗护"
        },
        {
          icon:require('@/assets/home-clothing7.png'),
          title:"展藏品洗养护"
        },
        {
          icon:require('@/assets/home-clothing8.png'),
          title:"家居家私到家养护"
        },
      ],
      serviceProjectJian:[
        {
          icon:"../assets/ax-logo.png",
          title:"精品衣物"
        },
        {
          icon:"../assets/ax-logo.png",
          title:"鞋靴"
        },
        {
          icon:"../assets/ax-logo.png",
          title:"精品改衣"
        },
        {
          icon:"../assets/ax-logo.png",
          title:"家纺用品"
        },
        {
          icon:"../assets/ax-logo.png",
          title:"奢侈品"
        },
        {
          icon:"../assets/ax-logo.png",
          title:"特种衣物"
        },
        {
          icon:"../assets/ax-logo.png",
          title:"展藏品"
        },
        {
          icon:"../assets/ax-logo.png",
          title:"家居家私"
        },
      ],

      newsDataLeft:{},
      newsDataRight:{},

      qudaoShow: true,
      homenewsShow1: false,
      homenewsShow2: false,
      homenewsShow3: false,
      homenewsShow4: false,
      homenewsShow5: false,
    }
  },
  mounted(){
      window.addEventListener("scroll", this.handleScroll);
  },
  filters: {
    formatterDate: function (cellValue) {
      if (!cellValue) {
            return '';
        }
        return dayjs(Number(cellValue)).format('YYYY-MM-DD');
    }
  },
  created() {
    console.log('首页进入接口');
    this.$fetch("store/select/contentColumn").then(res => {
      console.log(res);
      res.map(item => {
        if(item.name == "新闻资讯"){
          this.$fetch("store/select/contentArticle",{from: 0, size: 20, id: item.id}).then(res => {
            console.log("store/select/contentArticle", res);
            this.newsDataLeft = res.items[0];
            this.newsDataRight = res.items[1];
          })
        }
      })
    })

    this.$exec('page.images','pages.Official').then(result => {
      this.homePageImg = result.data.data;
    })
    
  },
  methods: {
    handleScroll () { // 实现当滚动到指定位置，触发动画
      let scrollTop =  window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 获取窗口滚动条高度
      // this.gdjz('earth', 'earth animated bounceInDown', 50)

      // let top = document.documentElement.scrollTop || document.body.scrollTop;

      let _this = this
      let refArray = [
        {ref: 'homeImg', show: 'homeImg'},
        {ref: 'qudao', show: 'qudaoShow'},
        {ref: 'homenews1', show: 'homenewsShow1'},
        {ref: 'homenews2', show: 'homenewsShow2'},
        {ref: 'homenews3', show: 'homenewsShow3'},
        {ref: 'homenews4', show: 'homenewsShow4'},
        {ref: 'homenews5', show: 'homenewsShow5'},
      ]
      // refArray.forEach((r,i) => {
      //   // if(top >= (this.$refs[r.ref].offsetTop - this.$refs[r.ref].offsetHeight)){
      //   //   console.log('11111111', this.$refs[r.ref]);
      //   //   console.log(top, (this.$refs[r.ref].offsetTop - this.$refs[r.ref].offsetHeight))
      //   //   _this[r.show] = true
      //   // }

      // refArray.forEach((r,i) => {
      //   _this.gdjz(r.ref, 20, () => {
      //     _this[r.show] = true
      //   })
      // })


      refArray.forEach((r,i) => {
        let refDom = this.$refs[r.ref];
        if(refDom){
          var a,b,c,d;
          d = refDom.offsetTop // 元素距离相对父级的高度，这里父级指的是body
          c = refDom.getBoundingClientRect() // 元素距离相对父级的高度，这里父级指的是body
          a = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
          if((a + c.height) > (d + 80)){
            _this[r.show] = true
          }
        }
      })
    },
    gdjz (div, offset, callback) {
      let dom = this.$refs[div] // 等同于document.querySelector('.earth') true
      if(dom){
        var a,b,c,d;
        d = dom.offsetTop // 元素距离相对父级的高度，这里父级指的是body
        a = eval(d + offset)
        b = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop //  获取窗口滚动条高度
        c = document.documentElement.clientHeight || document.body.clientHeight // 获取浏览器可视区的高度
        if( b + c > a ) {
          callback && callback()
        }
      }
    },
  }
  
}
</script>
<style scoped lang="scss">
::v-deep .el-carousel__container{
  width: 100%;
  height: 50rem;
}
.swiper-pagination{
    left: 0;
    right: 0;
    bottom: 20px;
}
::v-deep .swiper-button-prev, .swiper-button-next{
  color: #00146E;
}
::v-deep .swiper-pagination-bullet{
    background: rgb(143, 143, 143);
    margin: 0 0.2rem;
}
::v-deep .swiper-pagination-bullet-active{
    background: #00146E;
}
.brand-icons{
  width: 100%;
}
.home{
    width: 100%;
    background: #F3F5FA;
    overflow: hidden;
    margin-top: -91px;
}
.home-mobile{
  display: none;
}
.home-img{
  width: 100%;
  height: 47rem;
}
.service-img{
  width: 1.5rem;
  height: 1.7rem;
  margin-top: 3rem;
}
.home-title{
  font-size: 2rem;
  margin: 1rem 0;
}
.home-paper{
  font-size: 1rem;
  margin-bottom: 3rem;
}
.service-project{
  display: inline-block;
  width: 10%;
  text-align: center;
  margin: 0 0.8rem;

  .project-img{
    width: 6.9rem;
    height: 6.9rem;
    background: #fff;
    border-radius: 50%;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    position: relative;

    img{
      // width: 4rem;
      // height: 3.8rem;
      width: 85%;
      transition: 0.5s;
    }

    .goods-list-project-img{
      position: absolute;
      // top: 23%;
      top: 50%;
      transform: translateY(-50%);
    }
    
    .goods-project-img{
      position: absolute;
      top: -100%;
    }
  }
  .project-img:hover {
    .goods-project-img{
      // top: 23%;
      top: 50%;
      transform: translateY(-50%);
    }

    .goods-list-project-img{
      position: absolute;
      top: 150%;
    }
  }

  .project-title{
    font-size: 1rem;
    margin-top: 1rem;
  }
}

.news-nav{
  display: flex;
  justify-content: space-between;
  margin: 3rem 12rem 0;

  .news-information{
    width: 45.5rem;
    text-align: left;

    img{
      width: 100%;
      height: 28.2rem;
    }

    .news-title{
      font-size: 1rem;
      margin: 1rem 0;
    }
    .news-time{
      font-size: 1rem;
      color: #999;
    }
  }
}

.news-btn{
  width: 15rem;
  height: 3.3rem;
  line-height: 3.3rem;
  text-align: center;
  border: 1px solid #00146E;
  font-size: 1rem;
  margin: 3rem auto;
  cursor: pointer;
}

// @media screen and (max-width: 768px) {
//   .home{
//     display: none;
//   }
//   .home-mobile{
//     display: block;

//     .home-mobile-img{
//       width: 100%;
//       height: 37rem;
//     }

//     .mobile-service-project{
//       width: 25%;
//       display: inline-block;
//       margin: 1rem 0;

//       .mobile-project-img{
//         justify-content: center;
//         width: 7rem;
//         height: 7rem;
//         background: #fff;
//         border-radius: 50%;
//         margin: auto;
//         align-items: center;
//         display: flex;

//         img{
//           width: 5rem;
//           height: 4.7rem;
//         }
//       }
//     }

//     .mobile-news-nav{
//       padding: 2rem;

//       .mobile-news-information{
//         display: flex;
//         margin: 1rem 0;

//         img{
//           width: 43%;
//           height: 8rem;
//         }

//         .mobile-news-list{
//           padding: 0 1rem;
//           text-align: left;

//           .news-title{
//             font-size: 1.5rem;
//           }
//           .news-time{
//             color: #999;
//             margin-top: 1rem;
//           }
//         }
//       }
//     }

//     .mobile-service-btn{
//       background: #00146E;
//       width: 8rem;
//       color: #fff;
//       height: 3rem;
//       line-height: 3rem;
//       margin: 2rem auto 0;
//     }
//     .mobile-news-btn{
//       background: #00146E;
//       width: 8rem;
//       color: #fff;
//       height: 3rem;
//       line-height: 3rem;
//       margin: 0 auto 2rem;
//     }
//   }
// }

.testenter{
  transform: translateY(0%)!important;  //滚动后的位置
  opacity: 1!important;  //滚动后显现
  transition: all .5s ease;
}
.test{  
  transform: translateY(10%);  //滚动前的位置
  opacity: 0;   //滚动前设置透明隐藏
}
</style>